module.exports = __webpack_public_path__ + "media/images/favicon-3fd6923d12f6c182602fd84bb42dde24.png";